var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"playorbiter8"},[_c('star-map'),_c('layer-html')],1)}
var staticRenderFns = []

export { render, staticRenderFns }